var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
import { getObservableT } from "../Infra/i18next";
const t = getObservableT("patients");
export class DocumentRetrievalReviewAndShareViewModel {
    constructor(parentModel) {
        this.parentModel = parentModel;
    }
    get locationsNeedingAuth() {
        return this.parentModel.locationsNeedingAuth;
    }
    get locationsCompleted() {
        return this.parentModel.locationsCompleted;
    }
    get organizationName() {
        return this.parentModel.organizationName;
    }
    get isStatic() {
        return this.parentModel.uiState.isStatic;
    }
    get supportingText() {
        var _a;
        return this.parentModel.isIAS
            ? t("Here’s a summary of the providers whose records we’ll access for your HealthEx Unified Record.")
            : t("Your records from the following providers will be shared with {{ organizationName }}.", {
                organizationName: (_a = this.organizationName) !== null && _a !== void 0 ? _a : "the organization",
            });
    }
    get buttonText() {
        return this.locationsNeedingAuth.length > 0
            ? t("Continue")
            : this.parentModel.isIAS
                ? t("Access records")
                : this.parentModel.isAIFlow
                    ? t("Connect my records")
                    : t("Share my records");
    }
    get title() {
        return this.parentModel.isIAS
            ? t("Review and access your records")
            : this.parentModel.isAIFlow
                ? t("Review and connect your records")
                : t("Review and share");
    }
    async handleContinueClick() {
        var _a, _b;
        await ((_b = (_a = this.parentModel).onRecordsShared) === null || _b === void 0 ? void 0 : _b.call(_a));
    }
}
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], DocumentRetrievalReviewAndShareViewModel.prototype, "locationsNeedingAuth", null);
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], DocumentRetrievalReviewAndShareViewModel.prototype, "locationsCompleted", null);
__decorate([
    computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], DocumentRetrievalReviewAndShareViewModel.prototype, "supportingText", null);
__decorate([
    computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], DocumentRetrievalReviewAndShareViewModel.prototype, "buttonText", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], DocumentRetrievalReviewAndShareViewModel.prototype, "title", null);
